import { fmtIDR } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { ListTree } from "lucide-react";

const lines = (r) => [
  ["h", "PENGHASILAN BRUTO"],
  ["1", "Gaji Pokok", r.gaji],
  ["2", "Tunjangan PPh (Gross-Up)", r.tunjangan_pph],
  ["3", "Tunjangan Lainnya, Uang Lembur dsb.", r.tunjangan_lain],
  ["", "— di antaranya Uang Lembur", r.lembur, true],
  ["5a", "Premi JKK — Jaminan Kecelakaan Kerja (perusahaan)", r.premi_jkk],
  ["5b", "Premi JKM — Jaminan Kematian (perusahaan)", r.premi_jkm],
  ["5c", "Premi BPJS Kesehatan (perusahaan)", r.premi_kes],
  ["5d", "Premi Asuransi Swasta (perusahaan)", r.premi_asuransi],
  ["5e", "Premi BPJS input manual", r.premi_manual],
  ["5", "Jumlah Premi Asuransi Dibayar Pemberi Kerja", r.premi_total, false, true],
  ["7", "Tantiem, Bonus, THR", r.thr],
  ["8", "JUMLAH PENGHASILAN BRUTO", r.gross, false, true],
  ["h", "PENGURANGAN"],
  ["9", "Biaya Jabatan (5%, maks Rp500rb × bulan)", r.biaya_jabatan],
  ["10a", "Iuran JHT — Jaminan Hari Tua (dibayar karyawan)", r.iuran_jht],
  ["10b", "Iuran JP — Jaminan Pensiun (dibayar karyawan)", r.iuran_jp],
  ["10c", "Iuran BPJS input manual", r.iuran_manual],
  ["10", "Jumlah Iuran Pensiun / JHT", r.iuran_total, false, true],
  ["h", "PERHITUNGAN PPh 21 (PASAL 17)"],
  ["12", "Penghasilan Neto", r.netto, false, true],
  ["15", "PTKP", r.ptkp_amount],
  ["16", "PKP Setahun", r.pkp],
  ["17", "PPh 21 Terutang", r.annual_pph, false, true],
  ["18", "PPh 21 Sudah Dipotong (masa sebelumnya)", r.pph_prev],
  ["19", "PPh 21 Final Masa Terakhir (kurang/lebih potong)", r.pph_final, false, true],
  ["h", "INFORMASI (bukan pengurang pajak)"],
  ["", "Potongan BPJS Kesehatan Karyawan", r.pot_kes, true],
  ["", "Potongan Asuransi Karyawan", r.pot_asuransi, true],
  ["", "Potongan Hutang Karyawan", r.pot_hutang, true],
];

export function A1DetailDialog({ row }) {
  return (
    <Dialog>
      <DialogTrigger asChild><Button variant="ghost" size="icon" className="h-7 w-7" title="Rincian 1721-A1" data-testid={`a1-detail-${row.key || row.employee_id}`}><ListTree className="h-4 w-4" /></Button></DialogTrigger>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-auto">
        <DialogHeader><DialogTitle>Rincian 1721-A1 — {row.name}</DialogTitle>
          <DialogDescription className="text-xs">{row.employee_code ? `${row.employee_code} · ` : ""}{row.ptkp_status} · Masa {String(row.masa_awal).padStart(2, "0")}–{String(row.masa_akhir).padStart(2, "0")} ({row.months} bulan) · {row.status_bupot}{row.nik ? ` · NIK ${row.nik}` : ""}</DialogDescription></DialogHeader>
        <div className="text-sm divide-y divide-border" data-testid="a1-detail-table">
          {lines(row).map(([no, label, val, muted, bold], i) => no === "h"
            ? <p key={i} className="pt-3 pb-1 text-[11px] font-semibold tracking-wide text-muted-foreground">{label}</p>
            : (
              <div key={i} className={`flex items-center justify-between py-1.5 gap-3 ${bold ? "font-semibold" : ""} ${muted ? "text-muted-foreground text-xs" : ""}`}>
                <span><span className="inline-block w-9 text-xs text-muted-foreground">{no}</span>{label}</span>
                <span className="num whitespace-nowrap">{fmtIDR(val || 0)}</span>
              </div>
            ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
